import TcTooltip from 'components/UI/Tooltip/TcTooltip';
import useQuery from 'global/helperFunctions/useQuery';
import { FC, ReactNode } from 'react';

interface IMapToolIcon {
  title?: string;
  handleClick?: () => void;
  icon?: ReactNode;
}

const TcMapToolIcon: FC<IMapToolIcon> = ({ title, icon, handleClick }) => {
  const { query } = useQuery();

  return (
    <TcTooltip title={title} placement='right'>
      <div
        className={`flex gap-1 items-center justify-center cursor-pointer bg-t-bg-color hover:bg-t-layer-bg-color-hovered  py-1 border blink-animation ${
          query.searchPhrase ? 'rounded-md px-2' : 'rounded-2xl px-3'
        }`}
        onClick={handleClick}>
        {icon}
        {!query?.searchPhrase && <span className='font-bold text-xs'>جستجو</span>}
      </div>
    </TcTooltip>
  );
};

export default TcMapToolIcon;
